/* ============
 * Create Page
 * ============
 *
 * This page creates stock adjustments.
 */

import { mapGetters } from 'vuex';
import adjustmentService from './../../../../../services/adjustment';
import adjustmentTransformer from './../../../../../transformers/adjustment';
import warehouseService from './../../../../../services/warehouse';
import Forms from './../../../../../utils/forms/forms';
import productService from './../../../../../services/product';
import store from './../../../../../store';

export default {
  data() {
    return {
      formBasicInformation: new Forms({
        warehouseId: {
          value: '',
          type: 'select',
        },
        adjustmentTypeId: {
          value: '',
          type: 'select',
        },
        reason: {
          value: '',
          type: 'textarea',
        },
      }),
      loading: true,
      tabIndex: 'first',
      fields: {
        productId: {
          value: '',
          type: 'autocomplete',
          attributes: {
            isSearch: true,
            searchMethod: this.searchMethod,
            loading: true,
          },
        },
        batchId: {
          value: '',
          type: 'select',
        },
        currentAdjustment: {
          value: '0',
          type: 'text',
          disabled: true,
        },
        qty: {
          value: '0',
          type: 'text',
        },
      },

      isImport: true,
      isExport: true,
      download: this.downloadProduct,
      server: {
        url: '',
      },
      adjustmentTypeOptions: [],
    };
  },

  computed: {
    ...mapGetters({
      currentStockProducts: 'currentStockProductsCustom',
      warehouses: 'allWarehouses',
    }),

  },

  watch: {

    $route() {
      this.warehouseTarget();
    },

    'formBasicInformation.adjustmentTypeId': function (adjustmentTypeId) {
      this.renameLabel(adjustmentTypeId);
    },

    warehouses(warehouses) {
      const data = warehouses.items.filter(item => !item.isSharedToYou);
      this.formBasicInformation.setOptions('warehouseId', data.map(item => ({ id: item.id, name: item.name + (item.isLocked ? this.$t('static.warehouse.info.locked') : ''), disabled: item.isLocked })));
    },
    'formBasicInformation.warehouseId': function (warehouseId) {
      this.server = {
        url: `${process.env.API_LOCATION}/adjustments/${this.formBasicInformation.warehouseId}/import-product?token=${localStorage.getItem('id_token')}`,
        process: {
          onload: (res) => {
            const name = 'inventory.adjustment.stock.edit';
            // select the right value in the response here and return
            // return res;
            const obj = JSON.parse(res);
            this.$router.push({
              name,
              params: { id: obj.id },
            });
          },
        },
      };
      store.dispatch('setStockSelectedWarehouse', warehouseId);
    },
    stocks(stocks) {
      this.formBasicInformation.setOptions('stockId', stocks.items.map(c => (
        { id: c.id, name: c.code }
      )));
    },
    'formBasicInformation.stockId': function (stockId) {
      const stock = this.stocks.items
       .filter(p => p.id.toString() === stockId);

      // this.server = {
      //   url: `${process.env.API_LOCATION}/adjustments/${this.formBasicInformation.warehouseId}/import-product?token=${localStorage.getItem('id_token')}`,
      //   process: {
      //     onload: (res) => {
      //       const name = 'inventory.adjustment.stock.edit';
      //       // select the right value in the response here and return
      //       // return res;
      //       const obj = JSON.parse(res);
      //       this.$router.push({
      //         name,
      //         params: { id: obj.id },
      //       });
      //     },
      //   },
      // };
      // store.dispatch('setStockSelectedWarehouse', warehouseId);
    },
  },

  created() {
    this.loading = false;
  },

  methods: {

    warehouseTarget() {
      const warehouseIds = this.warehouses.items.map(item => (item.id));
      const targeId = this.$router.currentRoute.hash.substring(1);
      if (warehouseIds.indexOf(parseInt(targeId)) !== -1) {
        this.formBasicInformation.setFieldValue('warehouseId', targeId);
      }
    },

    renameLabel(adjustmentTypeId) {
      let type = '';
      this.adjustmentTypeOptions.forEach((item) => {
        if (parseInt(item.id) === parseInt(adjustmentTypeId)) {
          type = item.name;
          return;
        }
      });

      if (type === 'Wastage' || type === 'Destruction') {
        jQuery('.th-qty').text(this.$t('table.adjustment.products.qty.customDeduct'));
      } else {
        jQuery('.th-qty').text(this.$t('table.adjustment.products.qty.label'));
      }
    },

    /**
     * Method to store the client
     */
    store() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const client = adjustmentTransformer.send(
        Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts, type: 4 })
      );
      adjustmentService.store(client)
        .then(() => {
          this.$message({
            message: this.$t('static.adjustment.create.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'inventory.adjustment.index',
          });
        }).catch((errors) => {
          const message = errors.message;
          this.formBasicInformation.loading = false;
          this.formBasicInformation.recordErrors(errors);
          if (errors.message) {
            this.$message({
              showClose: true,
              message,
              customClass: 'error',
            });
          }
        });
    },

    saveDraft() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const client = adjustmentTransformer.send(
        Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts, type: 1 })
      );
      adjustmentService.saveDraft(client)
        .then(() => {
          this.$message({
            message: this.$t('static.adjustment.draft.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'inventory.adjustment.index',
          });
        }).catch((errors) => {
          const message = errors.message;
          this.formBasicInformation.loading = false;
          this.formBasicInformation.recordErrors(errors);
          if (errors.message) {
            this.$message({
              showClose: true,
              message,
              customClass: 'error',
            });
          }
        });
    },
    searchMethod(search, field) {
      return Promise.all([
        productService.searchAll({ search }),
      ]);
    },
    downloadProduct() {
      adjustmentService.downloadProduct(this.formBasicInformation.warehouseId);
    },
  },
  mounted() {
    store.dispatch('allCurrentStockProductsCustom', []);
    Promise.all([
      warehouseService.all(),
      adjustmentService.adjustmentType(),
    ]).then((data) => {
      store.dispatch('setStockSelectedWarehouse', 0);
      this.adjustmentTypeOptions = data[1].map(item => ({
        id: item.id,
        name: this.$t(`form.adjustment.adjustmentTypeList.${item.name.toLowerCase()}`),
      }));
      this.formBasicInformation.setOptions('adjustmentTypeId', this.adjustmentTypeOptions);
      this.formBasicInformation.setFieldValue('adjustmentTypeId', this.$t('form.adjustment.adjustmentTypeList.adjustment'));
      this.warehouseTarget();
    });
  },

  components: {
    VForm: require('./../../../../../components/form/form.vue'),
    VProductsTable: require('./../../../../../components/productTableWithCustomForm/productTableWithCustomForm.vue'),
    VMessage: require('./../../../../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/adjustment/stock/create/create.js